module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsYearly@2x.829ed1a.jpg";